import axios from "axios";
axios.defaults.timeout = 5000;
// axios.defaults.baseURL = '/api';
axios.defaults.baseURL="http://manage.zhtd.hk/api.php";
// axios.defaults.headers.post['Content-Type']  = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.interceptors.request.use(
//   config => {
//     const token = store.state.token;
//     token && (config.headers.Authorization = token);
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );
// axios.interceptors.response.use(
//   response => {
//     if (response.data.code === 403) {
//       Router.push({
//         name: "login"
//       });
//     }
//     return response;
//   },
//   error => {
//     return Promise.resolve(error.response);
//   }
// );
const ajax={
  post:function(url,params={}){
      return new Promise( (resolve ,reject) => {
          axios.post(url,params)
          .then( (response) => {
              resolve(response)
          })
          .catch ( (error) => {
              reject(error)
          })
      })
  },

  get:function( url ,params={}){
      return new Promise ( (resolve ,reject) => {
          axios.get(url,{
              params:params
          })
          .then( (response) => {
              resolve(response)
          })
          .catch ((error)=> {
              reject(error)
          })
      })
  },
  put:function (url ,data={}){
      return new Promise( (resolve, reject) => {
          axios.put(url,data)
          .then( (response) => {
               resolve(response)
          })
          .catch( (error) => {
              reject(error)
          })
      })
  },

  del:function(url ,params={}){
      return new Promise((resolve,reject) => {
        axios.delete(url,{
            data:params
        })
          .then( (response) => {
              resolve(response)
          })
          .catch ((error)=> {
              reject(error)
          })
      })
  }
}
export default ajax;